import { FORMAT_TIME } from 'constants/days';
import moment from 'moment';
import React from 'react';
import { IAppointment } from 'types/appointments';
import { metersToMiles } from 'utils';

import { INotaryAppointments } from '../types';

interface IAppointmentRow {
  appointment: IAppointment | INotaryAppointments;
  isNew?: boolean;
}

const AppointmentRow: React.FC<IAppointmentRow> = ({ appointment, isNew }) => {
  const timeStart = moment(appointment.date || '').format(FORMAT_TIME);
  const timeEnd = moment(timeStart, FORMAT_TIME)
    .add((appointment.duration || 0) / 3600, 'h')
    .format(FORMAT_TIME);
  return (
    <div className='appointment-row'>
      <div className='appointment-time'>
        {timeStart.toString()} - {timeEnd.toString()}
      </div>
      <div className='appointment-description'>
        {appointment.description || 'Notary Appointment'} {isNew ? '(New)' : ''}
      </div>
      <div className='appointment-distance'>{metersToMiles(appointment.distance || 0).toFixed(1)} miles</div>
      <div />
    </div>
  );
};

export default AppointmentRow;
